import api from './baseApi';
import { OauthTokenResponse } from '../../typings/etsy/auth';

export const getEtsyInvalidSessions = async (): Promise<any> => {
    try {
        const response = await api.get(`etsy/shops/invalid_sessions`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getEtsyLogin = (): Promise<OauthTokenResponse> =>
    api.get<OauthTokenResponse>('etsy/requestToken').then(({ data }) => data);

export const setEtsyRequestToken = async (tokenSecret: string, state: string, shop: string): Promise<string> => {
    const response = await api.put(
        'etsy/requestToken',
        {
            tokenSecret,
            state
        },
        {
            params: {
                shop: shop
            }
        }
    );
    return response.data.login_url;
};
